import { Box, Card, CardContent, Divider, Typography } from "@mui/material";
import { DateFormatter } from "app/shared/ReuseComponents/DateFormatter";
import React from "react";

const MobileTimesheetCards = ({
  timesheetLists,
  openRows,
  toggleOpen,
  getStatus,
}) => {
  return (
    <>
      {timesheetLists?.length > 0 ? (
        timesheetLists?.map((timesheet, sheetIndex) =>
          timesheet?.Timemanagement?.map((dayData, dayIndex) => {
            const key = `${sheetIndex}-${dayIndex}`;

            return (
              <Card
                key={key}
                sx={{
                  mb: 2,
                  borderRadius: 2,
                  border: "1px solid #e0e0e0",
                }}
              >
                <CardContent>
                  {/* Date + Status */}
                  <Box
                    sx={{
                      width: "100%",
                      display: "flex",
                      justifyContent: "space-between",
                    }}
                  >
                    <Typography fontWeight={600} width={"100px"}>
                      <DateFormatter date={dayData?.date} />
                    </Typography>

                    <Typography fontWeight={600} textAlign={"right"}>
                      {getStatus(timesheet)}
                    </Typography>
                  </Box>

                  <Divider sx={{ my: 1 }} />

                  {/* Employee */}
                  <Typography variant="body2">
                    <strong>Employee:</strong>{" "}
                    {timesheet?.Employee_Id?.Employee_FirstName}{" "}
                    {timesheet?.Employee_Id?.Employee_LasttName || ""}
                  </Typography>

                  <Typography variant="body2">
                    <strong>Code:</strong> {timesheet?.Employee_Id?.Employee_Id}
                  </Typography>

                  <Typography variant="body2">
                    <strong>Timesheet:</strong> {timesheet?.Timesheet_Name}
                  </Typography>

                  <Divider sx={{ my: 1 }} />

                  {/* Time */}
                  <Typography variant="body2">
                    <strong>From:</strong> {dayData?.fromTime}
                  </Typography>
                  <Typography variant="body2">
                    <strong>To:</strong> {dayData?.toTime}
                  </Typography>

                  <Typography variant="body2">
                    <strong>Total:</strong> {dayData?.totalTime}
                  </Typography>

                  {/* Expand */}
                  {dayData?.taskCarried?.length > 0 && (
                    <>
                      <Divider sx={{ my: 1 }} />
                      <Typography
                        variant="body2"
                        color="primary"
                        sx={{ cursor: "pointer" }}
                        onClick={() => toggleOpen(key)}
                      >
                        {openRows?.includes(key)
                          ? "Hide Tasks ▲"
                          : "View Tasks ▼"}
                      </Typography>

                      {openRows?.includes(key) &&
                        dayData?.taskCarried?.map((task, index) => (
                          <Card
                            key={index}
                            sx={{
                              mt: 1,
                              p: 1,
                              backgroundColor: "#F3FCFF",
                              boxShadow: "none",
                              borderRadius: 1,
                            }}
                          >
                            <Typography variant="body2">
                              <strong>Type:</strong> {task?.taskType}
                            </Typography>
                            <Typography variant="body2">
                              <strong>Task:</strong> {task?.task}
                            </Typography>
                            <Typography variant="body2">
                              <strong>Hours:</strong> {task?.hours}
                            </Typography>
                          </Card>
                        ))}
                    </>
                  )}
                </CardContent>
              </Card>
            );
          }),
        )
      ) : (
        <Typography align="center" mt={3}>
          No Records
        </Typography>
      )}
    </>
  );
};

export default MobileTimesheetCards;
